// https://github.com/InteractiveAdvertisingBureau/openrtb/blob/master/extensions/2.x_official_extensions/eids.md#list--agent-types-
export enum AgentType {
  browserBased = 1,
  inAppID = 2,
  personBased = 3
}
